import { NgFor, NgIf, NgClass } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output, ChangeDetectorRef, OnChanges, OnInit, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { Subscription } from 'rxjs';
import { NotificationFilterService } from './notification-filter.service';

export interface FilterOptions {
  typeFilters: string[];
  statusFilters: string[];
  countryFilters: string[];
  notificationOwnerFilters: string[];
  searchText: string;
}

@Component({
  selector: 'dl-notification-filter',
  standalone: true,
  imports: [OneWebComponentsAngularModule, NgIf, NgClass],
  templateUrl: './notification-filter.component.html',
  styleUrl: './notification-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})
export class NotificationFilterComponent implements OnInit, OnChanges {

  qnsbnService = inject(QnSbnService);
  changeDetectorRef = inject(ChangeDetectorRef);

  @Input() filterOptions = { types: [], statuses: [], country:[], notificationOwners: [] };
  @Output() filterOptEmit = new EventEmitter();

  public isClearVis: boolean = false;
  public typeFilters: [];
  public statusFilters: [];
  public filterDataObject: FilterOptions;
  public typeList = [];
  public statusList = [];
  typeSelVal: any;
  statusSelVal: any;
  countrySelVal: any;
  notificationOwnerSelVal: any;
  filterOptSelG = { typeFilters: [], statusFilters: [], countryFilters: [], notificationOwnerFilters: [] };
  isClearbtnVisi: boolean = false;
  public countryList = [];
  public countryFilters = [];
  public notificationOwnerList = [];

  private _notificationFilterServiceSubscription: Subscription;

   public constructor(private notificationFilterService: NotificationFilterService) {
    this.filterDataObject = { typeFilters: [], statusFilters: [], countryFilters: [], notificationOwnerFilters: [], searchText: '' };
  }

   public ngOnInit(): void {
    const typeFilVal = this.notificationFilterService.typeFilStore;
    const statusFilVal = this.notificationFilterService.statusFilStore;
    const countryFilVal = this.notificationFilterService.countryFilStore;
    const notificationOwnerFilVal = this.notificationFilterService.notificationOwnerFilStore;

    if(typeFilVal.length > 0){
      this.typeSelVal = typeFilVal.map(f => f.value);
      this.filterOptSelG.typeFilters = [...this.typeSelVal];
    }
    if(statusFilVal.length > 0){
      this.statusSelVal = statusFilVal.map(f => f.value);
      this.filterOptSelG.statusFilters = [...this.statusSelVal];
    }
    if(countryFilVal.length > 0){
      this.countrySelVal = countryFilVal.map(f => f.value);
      this.filterOptSelG.countryFilters = [...this.countrySelVal];
    }
    if(notificationOwnerFilVal.length > 0){
      this.notificationOwnerSelVal = notificationOwnerFilVal.map(f => f.value);
      this.filterOptSelG.notificationOwnerFilters = [...this.notificationOwnerSelVal];
    }

    if(typeFilVal.length > 0 || statusFilVal.length > 0 || countryFilVal.length > 0 || notificationOwnerFilVal.length > 0){
      this.isClearVis = true;
      this.isClearbtnVisi = true;
    }

    if(this.notificationFilterService.typeListStore){
      this.typeList = this.notificationFilterService.typeListStore;
      if(this.notificationFilterService.typeFilStore){
        this.notificationFilterService.typeFilStore.forEach(ele=>{
          this.typeList.map(item=>{
            if(ele.value===item.value){
              let index = this.typeList.indexOf(item);
              this.typeList[index]=ele;
            }
          })
        })
      }
    }
    else{
      this._notificationFilterServiceSubscription = this.notificationFilterService.typeFilterobservable$.subscribe(ele => {
        if (ele.label) {
          let checkEle = true;
          this.typeList.some((el, ind) => {
            if (el.label.trim() === ele.label.trim()) {
              checkEle = false;
            }
          });
          if (checkEle) this.typeList.push(ele);
        }
        this.notificationFilterService.typeListStore = this.typeList;
        return;
      });
    }
    
    if(this.notificationFilterService.statusListStore){
      this.statusList = this.notificationFilterService.statusListStore;
      if(this.notificationFilterService.statusFilStore){
        this.notificationFilterService.statusFilStore.forEach(ele=>{
          this.statusList.map(item=>{
            if(ele.value===item.value){
              let index = this.statusList.indexOf(item);
              this.statusList[index]=ele;
            }
          })
        })
      }
    }
    else{
      this._notificationFilterServiceSubscription = this.notificationFilterService.statusFilterobservable$.subscribe(ele => {
        if (ele.label) {
          let checkEle = true;
          this.statusList.some((el, ind) => {
            if (el.label.trim() === ele.label.trim()) {
              checkEle = false;
            }
          });
          if (checkEle) this.statusList.push(ele);
        }
        this.notificationFilterService.statusListStore = this.statusList;
        return;
      });
    }
    
    if(this.notificationFilterService.countryListStore){
      this.countryList = this.notificationFilterService.countryListStore;
      if(this.notificationFilterService.countryFilStore){
        this.notificationFilterService.countryFilStore.forEach(ele=>{
          this.countryList.map(item=>{
            if(ele.value===item.value){
              let index = this.countryList.indexOf(item);
              this.countryList[index]=ele;
            }
          })
        })
      }
    }
    else{
      this._notificationFilterServiceSubscription = this.notificationFilterService.countryFilterobservable$.subscribe(ele => {
        if (ele.label) {
          let checkEle = true;
          this.countryList.some((el, ind) => {
            if (el.label.trim() === ele.label.trim()) {
              checkEle = false;
            }
          });
          if (checkEle) this.countryList.push(ele);
        }
        this.notificationFilterService.countryListStore = this.countryList;
        return;
      });
    }

    if(this.notificationFilterService.notificationOwnerListStore){
      this.notificationOwnerList = this.notificationFilterService.notificationOwnerListStore;
      if(this.notificationFilterService.notificationOwnerFilStore){
        this.notificationFilterService.notificationOwnerFilStore.forEach(ele=>{
          this.notificationOwnerList.map(item=>{
            if(ele.value===item.value){
              let index = this.notificationOwnerList.indexOf(item);
              this.notificationOwnerList[index]=ele;
            }
          })
        })
      }
    }
    else{
      this._notificationFilterServiceSubscription = this.notificationFilterService.notificationOwnerFilterobservable$.subscribe(ele => {
        if (ele.label) {
          let checkEle = true;
          this.notificationOwnerList.some((el, ind) => {
            if (el.label.trim() === ele.label.trim()) {
              checkEle = false;
            }
          });
          if (checkEle) this.notificationOwnerList.push(ele);
        }
        this.notificationFilterService.notificationOwnerListStore = this.notificationOwnerList;
        return;
      });
    }

}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['filterOptions'] && changes['filterOptions'].currentValue) {
      this.changeDetectorRef.detectChanges();
    }
  }

   public clear(){
    this.typeSelVal = [];
    this.statusSelVal = [];
    this.countrySelVal = [];
    this.notificationOwnerSelVal = [];

    this.filterOptSelG = { typeFilters: [], statusFilters: [], countryFilters: [], notificationOwnerFilters: [] };
    this.filterOptEmit.emit({ ...this.filterOptSelG });

    this.notificationFilterService.setTypeFilStore([]);
    this.notificationFilterService.setStatusFilStore([]);
    this.notificationFilterService.setCountryFilStore([]);
    this.notificationFilterService.setNotificationOwnerFilStore([]);

  
    this.isClearVis = false;
    this.isClearbtnVisi = false;
  }

  public isClear(){
    // Determine visibility based on current selection values (not FormControls)
    const hasAny = (this.typeSelVal?.length || 0) > 0
      || (this.statusSelVal?.length || 0) > 0
      || (this.countrySelVal?.length || 0) > 0
      || (this.notificationOwnerSelVal?.length || 0) > 0;
    this.isClearVis = hasAny;
  }

  // clear() {
  //   this.typeSelVal = [];
  //   this.statusSelVal = [];
  //   this.countrySelVal = [];
  //   this.updateTypes([]);
  //   this.updateStatus([]);
  //   this.updateCountry([]);
  //   this.isClearbtnVisi = false;
  // }

  typeListValue(event: any) {
    // Handle different event structures
    const types = event?.detail || event?.value || event || [];
    
    
    // Update typeSelVal to persist selection in the dropdown
    this.typeSelVal = types;
    
    this.updateTypes(types);
    this.updateClearVisibility();
    
    // Persist to service for navigation persistence
    this.notificationFilterService.setTypeFilStore(types);
  }

  statusListValue(event: any) {
    const status = event?.detail || event?.value || event || [];
    
    // Update statusSelVal to persist selection in the dropdown
    this.statusSelVal = status;
    
    this.updateStatus(status);
    this.updateClearVisibility();
    
    // Persist to service for navigation persistence
    this.notificationFilterService.setStatusFilStore(status);
  }

  countryListValue(event: any) {
    const country = event?.detail || event?.value || event || [];
    
    // Update countrySelVal to persist selection in the dropdown
    this.countrySelVal = country;
    
    this.updateCountry(country);
    this.updateClearVisibility();
    
    // Persist to service for navigation persistence
    this.notificationFilterService.setCountryFilStore(country);
  }

  notificationOwnerListValue(event: any) {
    const owners = event?.detail || event?.value || event || [];
    this.notificationOwnerSelVal = owners;
    this.updateNotificationOwner(owners);
    this.updateClearVisibility();
    this.notificationFilterService.setNotificationOwnerFilStore(owners);
  }

  updateTypes(types: any) {
   
    
    if (types.length > 0) {
      this.filterOptSelG.typeFilters = types;
    };
    if (types.length <= 0) {
      this.filterOptSelG.typeFilters = [];
    };
    this.filterOptEmit.emit({ ...this.filterOptSelG });
  }

  updateStatus(status: any) {
    if (status.length > 0) {
      this.filterOptSelG.statusFilters = status;
    };
    if (status.length <= 0) {
      this.filterOptSelG.statusFilters = [];

    };
    this.filterOptEmit.emit({ ...this.filterOptSelG });
  }

  updateCountry(country: any) {
    if (country.length > 0) {
      this.filterOptSelG.countryFilters = country;
    };
    if (country.length <= 0) {
      this.filterOptSelG.countryFilters = [];

    };
    this.filterOptEmit.emit({ ...this.filterOptSelG });
  }

  updateNotificationOwner(owners: any) {
    this.filterOptSelG.notificationOwnerFilters = owners?.length > 0 ? owners : [];
    this.filterOptEmit.emit({ ...this.filterOptSelG });
  }

  private updateClearVisibility() {
    this.isClearVis = (
      (this.filterOptSelG.typeFilters?.length || 0) > 0 ||
      (this.filterOptSelG.statusFilters?.length || 0) > 0 ||
      (this.filterOptSelG.countryFilters?.length || 0) > 0 ||
      (this.filterOptSelG.notificationOwnerFilters?.length || 0) > 0
    );
    this.isClearbtnVisi = this.isClearVis;
  }
}